import { render, staticRenderFns } from "./RegistryRegTypePage.vue?vue&type=template&id=f7ed5898"
import script from "./RegistryRegTypePage.vue?vue&type=script&lang=js"
export * from "./RegistryRegTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports